const forPreferenceCenterPhoneNumberInput = require("./forPreferenceCenterPhoneNumberInput");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function showPreferenceCenterPhoneNumberField(preferenceCenter) {
    forPreferenceCenterPhoneNumberInput(preferenceCenter, input => {
        const parent = input.closest(".preference-center-input-field");

        if (parent instanceof HTMLElement) {
            parent.style.display = "";
        }
    });
}
